import React from "react";
import { motion } from "framer-motion";
import { Sun, Sandwich, Moon, Cookie, Cake, Leaf } from "lucide-react";

const MEALS = [
  {
    icon: Sun,
    title: "Desayunos",
    desc: "Energía nutritiva para empezar el día con calma.",
    img: "/img/meal-desayunos.webp",
  },
  {
    icon: Sandwich,
    title: "Almuerzos",
    desc: "Platos completos, equilibrados y deliciosos.",
    img: "/img/meal-almuerzos.webp",
  },
  {
    icon: Moon,
    title: "Cenas",
    desc: "Suaves y ligeras para dormir mejor en familia.",
    img: "/img/meal-cenas.webp",
  },
  {
    icon: Cookie,
    title: "Meriendas",
    desc: "Snacks saludables que aman los niños.",
    img: "/img/meal-meriendas.webp",
  },
  {
    icon: Leaf,
    title: "Vegetarianas",
    desc: "Opciones a base de plantas para toda la familia.",
    img: "/img/meal-vegetarianas.webp",
  },
  {
    icon: Cake,
    title: "Postres saludables",
    desc: "Dulces sin culpa, llenos de sabor y nutrición.",
    img: "/img/meal-postres.webp",
  },
];

export default function MealCategories() {
  return (
    <section
      id="contenido"
      data-testid="meal-categories-section"
      className="bg-[#F4EBDE] py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-[11px] tracking-[0.22em] uppercase font-semibold text-[#849983]">
            Categorías incluidas
          </p>
          <h2 className="mt-4 font-serif-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-[#2A302A]">
            Todo lo que necesitas en un <em className="italic">solo ebook</em>.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-[#576057]">
            Recetas, menús, planificación y guía nutricional para cada etapa.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {MEALS.map((m, i) => (
            <motion.article
              key={m.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              whileHover={{ y: -6 }}
              data-testid={`meal-card-${i}`}
              className="group relative rounded-[1.75rem] overflow-hidden bg-white border border-[#E8DDC9] shadow-[0_12px_40px_rgba(78,60,40,0.06)] hover:shadow-[0_22px_60px_rgba(78,60,40,0.14)] transition-all duration-500"
            >
              <div className="relative h-56 md:h-64 overflow-hidden">
                <img loading="lazy" decoding="async"
                  src={m.img}
                  alt={m.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
                <div className="absolute top-4 left-4 inline-flex items-center gap-2 bg-white/95 backdrop-blur rounded-full pl-2 pr-3.5 py-1.5 shadow-sm">
                  <span className="w-6 h-6 rounded-full bg-[#849983]/15 flex items-center justify-center">
                    <m.icon className="h-3 w-3 text-[#849983]" strokeWidth={2} />
                  </span>
                  <span className="text-[11px] tracking-wider uppercase font-semibold text-[#2A302A]">
                    {m.title}
                  </span>
                </div>
              </div>
              <div className="p-6 md:p-7">
                <h3 className="font-serif-display text-2xl text-[#2A302A] leading-tight">
                  {m.title}
                </h3>
                <p className="text-sm text-[#576057] leading-relaxed mt-2">{m.desc}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
